module.exports = __webpack_public_path__ + "static/media/MinPrice.122a9af2.svg";